import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import UserAvatar from "../common/UserAvatar";
import { useAuth } from "../auth/AuthContext";
import { useContext } from "react";
import { GlobalContext } from "../../contexts/GlobalContext";
import { usePermissions } from "../../hooks/usePermissions";
import { CAPABILITIES } from "../../auth/permissions";

import { Tooltip, Menu, MenuItem, IconButton as MuiIconButton } from "@mui/material";

// import useAuth from "../../hooks/useAuth";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function NavbarUserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState(null);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { globalData } = useContext(GlobalContext);
  const { hasPermission } = usePermissions();
  const canOpenAdminPanel = hasPermission(CAPABILITIES.adminPanel, "R");
  const hasProfilePhoto = Boolean(globalData?.profilePhotoFileId);
  const accountDisplayName = globalData?.displayName || globalData?.userName || globalData?.email || "";

  // const { instance } = useMsal();

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleLogout = async () => {
    closeMenu();
    // Server-side revoke first (needs tokens still in sessionStorage), then clear locally.
    await logout();
    navigate("/dashboard");
    navigate(0);
  };

  const handleProfile = () => {
    navigate("/profile?view=account");
    closeMenu();
  };

  const handleAdmin = () => {
    navigate("/admin");
    closeMenu();
  };

  return (
    <React.Fragment>
      <Tooltip title="Profile">
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large"
        >
          <UserAvatar
            profilePhotoFileId={hasProfilePhoto ? globalData.profilePhotoFileId : null}
            displayName={accountDisplayName}
            size={40}
            sx={
              hasProfilePhoto
                ? { border: "2px solid", borderColor: "rgba(255,255,255,0.5)" }
                : {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    fontWeight: 600,
                    fontSize: "0.95rem",
                  }
            }
          />
        </IconButton>
      </Tooltip>
      <Menu id="menu-appbar" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        <MenuItem onClick={handleProfile}>Profile</MenuItem>
        {canOpenAdminPanel && <MenuItem onClick={handleAdmin}>Admin Panel</MenuItem>}
        <MenuItem onClick={() => handleLogout("redirect")}>Sign out</MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
